module.exports = __webpack_public_path__ + "static/sport/bgmobile.6462adf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ldp/bgmobile.jpg
// module id = LFl5
// module chunks = 0